import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for edit strategies
export const EditStrategies = createSlice({
  name: "EditStrategies",
  initialState: {
    isLoading: false,
    isSuccess: false,
    api_completed: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    edit_EditStrategies: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_EditStrategies: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_EditStrategies: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.api_completed = true;
      state.isSuccess = false;
      state.switchResponse = true;
    },
    EditStrategies_is_success: (state) => {
      state.isSuccess = false;
    },
    EditStrategies_complete_api: (state) => {
      state.api_completed = false;
    },
    false_switchstrategies_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default EditStrategies.reducer;
export const {
  edit_EditStrategies,
  success_api_call_EditStrategies,
  EditStrategies_complete_api,
  failure_api_call_EditStrategies,
  EditStrategies_is_success,
  false_switchstrategies_response
} = EditStrategies.actions;
